import type { FC, ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";

import clsx from "clsx";
import styles from "./Tab.module.scss";

export type TabOption<Key extends string> = {
  value: Key;
  label: ReactNode;
};

type TabProps = {
  label: ReactNode;
  active?: boolean;
  className?: string;
  onClick?: () => void;
};

export const Tab: FC<TabProps> = ({
  label,
  active,
  onClick,
  className,
  ...rest
}) => {
  const [block, cn] = useModuleBEM(styles, "Tab", { active });

  return (
    <button className={clsx(block, className)} onClick={onClick} {...rest}>
      <span className={cn("label")}>{label}</span>
    </button>
  );
};
